module.exports = __webpack_public_path__ + "static/media/cocktails.2e3b6ec5.jpg";